import { SearchSeparator } from "@/components/ui/search"

const IcdCodeSeparator = () => <SearchSeparator className="-mx-2 my-1" />
export { IcdCodeSeparator }
